import React from "react";
import { Link } from "react-router-dom";
import { useB2BTranslation } from "../B2BShared/hooks/useB2BTranslation";
import { ArrowLeft, Calendar, MapPin, Users, Clock } from "lucide-react";
import "./B2BEvents.css";

const B2BEvents: React.FC = () => {
  const { tEvents, tCommon } = useB2BTranslation();

  return (
    <div className="b2b-events-container">
      {/* Header */}
      <div className="b2b-events-header">
        <Link
          to="/gcb"
          className="b2b-events-back-button"
        >
          <ArrowLeft size={20} />
          {tCommon("back")} {tCommon("to")} GCB
        </Link>
        <h1>{tEvents("title")}</h1>
        <p>{tEvents("description")}</p>
      </div>

      {/* Events Grid */}
      <div className="b2b-events-grid">
        {/* Event Card 1 */}
        <div className="b2b-event-card featured">
          <div className="event-badge">{tEvents("featured")}</div>
          <div className="event-image">
            <div className="event-image-placeholder">🎯</div>
          </div>
          <div className="event-content">
            <h3>{tEvents("networkingSummit.title")}</h3>
            <p className="event-description">
              {tEvents("networkingSummit.description")}
            </p>
            <div className="event-details">
              <div className="event-detail">
                <Calendar size={16} />
                <span>{tEvents("networkingSummit.date")}</span>
              </div>
              <div className="event-detail">
                <MapPin size={16} />
                <span>{tEvents("networkingSummit.location")}</span>
              </div>
              <div className="event-detail">
                <Clock size={16} />
                <span>{tEvents("networkingSummit.time")}</span>
              </div>
              <div className="event-detail">
                <Users size={16} />
                <span>{tEvents("networkingSummit.participants")}</span>
              </div>
            </div>
            <div className="event-footer">
              <span className="event-price">
                {tEvents("networkingSummit.price")}
              </span>
              <span className="event-category">
                {tEvents("categories.networking")}
              </span>
            </div>
            <button className="register-button">
              {tEvents("registerNow")}
            </button>
          </div>
        </div>

        {/* Event Card 2 */}
        <div className="b2b-event-card">
          <div className="event-image">
            <div className="event-image-placeholder">📱</div>
          </div>
          <div className="event-content">
            <h3>{tEvents("digitalMarketing.title")}</h3>
            <p className="event-description">
              {tEvents("digitalMarketing.description")}
            </p>
            <div className="event-details">
              <div className="event-detail">
                <Calendar size={16} />
                <span>{tEvents("digitalMarketing.date")}</span>
              </div>
              <div className="event-detail">
                <MapPin size={16} />
                <span>{tEvents("digitalMarketing.location")}</span>
              </div>
              <div className="event-detail">
                <Clock size={16} />
                <span>{tEvents("digitalMarketing.time")}</span>
              </div>
              <div className="event-detail">
                <Users size={16} />
                <span>{tEvents("digitalMarketing.participants")}</span>
              </div>
            </div>
            <div className="event-footer">
              <span className="event-price">
                {tEvents("digitalMarketing.price")}
              </span>
              <span className="event-category">
                {tEvents("categories.workshop")}
              </span>
            </div>
            <button className="register-button">
              {tEvents("registerNow")}
            </button>
          </div>
        </div>

        {/* Event Card 3 */}
        <div className="b2b-event-card featured">
          <div className="event-badge">Featured</div>
          <div className="event-image">
            <div className="event-image-placeholder">💰</div>
          </div>
          <div className="event-content">
            <h3>Investment Forum</h3>
            <p className="event-description">
              Connect with investors and explore funding opportunities. Pitch
              your business ideas to potential investors.
            </p>
            <div className="event-details">
              <div className="event-detail">
                <Calendar size={16} />
                <span>April 5, 2024</span>
              </div>
              <div className="event-detail">
                <MapPin size={16} />
                <span>Financial District</span>
              </div>
              <div className="event-detail">
                <Clock size={16} />
                <span>10:00 - 17:00</span>
              </div>
              <div className="event-detail">
                <Users size={16} />
                <span>200 participants</span>
              </div>
            </div>
            <div className="event-footer">
              <span className="event-price">£200</span>
              <span className="event-category">Investment</span>
            </div>
            <button className="register-button">Register Now</button>
          </div>
        </div>

        {/* Event Card 4 */}
        <div className="b2b-event-card">
          <div className="event-image">
            <div className="event-image-placeholder">🚀</div>
          </div>
          <div className="event-content">
            <h3>Startup Pitch Competition</h3>
            <p className="event-description">
              Showcase your startup to potential investors and partners. Compete
              for funding and mentorship opportunities.
            </p>
            <div className="event-details">
              <div className="event-detail">
                <Calendar size={16} />
                <span>April 19, 2024</span>
              </div>
              <div className="event-detail">
                <MapPin size={16} />
                <span>Innovation Lab</span>
              </div>
              <div className="event-detail">
                <Clock size={16} />
                <span>16:00 - 20:00</span>
              </div>
              <div className="event-detail">
                <Users size={16} />
                <span>100 participants</span>
              </div>
            </div>
            <div className="event-footer">
              <span className="event-price">£50</span>
              <span className="event-category">Competition</span>
            </div>
            <button className="register-button">Register Now</button>
          </div>
        </div>

        {/* Event Card 5 */}
        <div className="b2b-event-card">
          <div className="event-image">
            <div className="event-image-placeholder">🌍</div>
          </div>
          <div className="event-content">
            <h3>International Trade Expo</h3>
            <p className="event-description">
              Global business opportunities and international partnerships.
              Connect with businesses from around the world.
            </p>
            <div className="event-details">
              <div className="event-detail">
                <Calendar size={16} />
                <span>May 3, 2024</span>
              </div>
              <div className="event-detail">
                <MapPin size={16} />
                <span>Exhibition Center</span>
              </div>
              <div className="event-detail">
                <Clock size={16} />
                <span>11:00 - 18:00</span>
              </div>
              <div className="event-detail">
                <Users size={16} />
                <span>500 participants</span>
              </div>
            </div>
            <div className="event-footer">
              <span className="event-price">£100</span>
              <span className="event-category">Exhibition</span>
            </div>
            <button className="register-button">Register Now</button>
          </div>
        </div>

        {/* Event Card 6 */}
        <div className="b2b-event-card">
          <div className="event-image">
            <div className="event-image-placeholder">🔗</div>
          </div>
          <div className="event-content">
            <h3>Supply Chain Conference</h3>
            <p className="event-description">
              Latest trends and innovations in supply chain management. Learn
              from industry leaders and network with experts.
            </p>
            <div className="event-details">
              <div className="event-detail">
                <Calendar size={16} />
                <span>April 12, 2024</span>
              </div>
              <div className="event-detail">
                <MapPin size={16} />
                <span>Conference Center</span>
              </div>
              <div className="event-detail">
                <Clock size={16} />
                <span>09:00 - 17:00</span>
              </div>
              <div className="event-detail">
                <Users size={16} />
                <span>300 participants</span>
              </div>
            </div>
            <div className="event-footer">
              <span className="event-price">£150</span>
              <span className="event-category">Conference</span>
            </div>
            <button className="register-button">Register Now</button>
          </div>
        </div>
      </div>

      {/* Call to Action */}
      <div className="b2b-events-cta">
        <h2>Don't See What You're Looking For?</h2>
        <p>
          Contact us to discuss custom GCB event solutions for your organization
        </p>
        <button className="cta-button">Contact Us</button>
      </div>
    </div>
  );
};

export default B2BEvents;

